import { render, staticRenderFns } from "./AtualizarWebHook.vue?vue&type=template&id=42492048&"
import script from "./AtualizarWebHook.vue?vue&type=script&lang=js&"
export * from "./AtualizarWebHook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports